import React from "react";
import PostAddForm from "../../../../components/forms/postItemsForm/index";
import { useState, useEffect } from "react";
import url from "../../../../config/axios";
import { useNavigate, useParams } from "react-router-dom";
import { SuccessNotify } from "../../../../constants/tostify";
import { FailedNotify } from "../../../../constants/tostify";
import { useSelector } from "react-redux";
import Loader from "../../../../components/Loader";
import { publishImage } from "../../../../helpers/imageupload";
import { useDropzone } from "react-dropzone";
import { decodeId } from "../../../../utils/idObfuscator";
import { useGetShopByIdQuery } from "../../../../features/shop/shopApiSlice";

const RecyclePostAdd = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { name } = useSelector((state) => state.user);
  const [isloading, setIsloading] = useState(false);
  const [displayimg, setDisplayimg] = useState();
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const cleanShopId = decodeId(id) || id || "";
  const { data: shopRes } = useGetShopByIdQuery(cleanShopId, {
    skip: !cleanShopId,
  });
  const shop = shopRes?.data?.Shop;

  const [data, setData] = useState({
    category: "",
    subCategory: ""
  });

  const Handledata = (e) => {
    const raw = e.target.value || "";
    const dot = raw.indexOf(".");
    let idPart = raw;
    let namePart = "";
    if (dot !== -1) {
      idPart = raw.slice(0, dot);
      namePart = raw.slice(dot + 1);
    }
    setData((prevState) => ({
      ...prevState,
      [e.target.name]: [idPart, namePart],
    }));
  };

  const categoryName = data?.category?.[1] || "";
  const categoryid = data?.category?.[0] || "";
  const subcategoryName = data?.subCategory?.[1] || "";
  const subcategoryid = data?.subCategory?.[0] || "";

  const [mygetitem, setMygetitem] = useState();
  useEffect(() => {
    const fromShop =
      shop?.shopCategory?.name ||
      shop?.shopCategory ||
      "";
    const fromStorage = localStorage.getItem('mycategory') || "";
    const resolved =
      (typeof fromShop === "string" && fromShop.trim()) ||
      (fromStorage && fromStorage !== "undefined" && fromStorage !== "null" && fromStorage.trim()) ||
      "";
    setMygetitem(resolved);
  }, [shop]);

  const [shopCategory, setShopCategory] = useState();
  const [shopCategorytwo, setShopCategorytwo] = useState();

  const onDrop = async (acceptedFiles) => {
    try {
      setIsUploading(true);
      setUploadProgress(0);

      const abc = await publishImage(acceptedFiles, (percent) => {
        setUploadProgress(percent);
      });
      setUserData((userData) => ({
        ...userData,
        images: abc
      }));

      setDisplayimg(abc);
    } catch (error) {
      FailedNotify("Failed! Try Again");
    } finally {
      setIsUploading(false);
      setUploadProgress(0);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop,
  });

  const [userData, setUserData] = useState({
    businessType: "recycledShop",
    userid: "",
    shopid: "",
    isSingleItem: false,
    isScrapItem: false,
    itemname: "",
    category: "",
    categoryid: "",
    subCategory: "",
    subCategoryid: "",
    price: "",
    country: "",
    city: "",
    state: "",
    quantity: "",
    unitOfMeasurement: "",
    currency: {
      currencyName: "",
    },
    images: [""],
    status: true,
  });

  useEffect(() => {
    setUserData((userData) => ({
      ...userData,
      category: categoryName,
      categoryid: categoryid,
      subCategory: subcategoryName,
      subCategoryid: subcategoryid
    }));
  }, [categoryid, categoryName, subcategoryName, subcategoryid]);

  const userDatahandler = (e) => {
    setIsloading(true);
    e.preventDefault();
    const payload = {
      ...userData,
      userid: userData.userid || shop?.userid?._id || shop?.userid || name?._id,
      shopid: userData.shopid || shop?._id || cleanShopId || id,
      country: userData.country,
      state: userData.state,
      city: userData.city,
      businessType: "recycledShop",
    };
    url
      .post("/shopitem", payload)
      .then(async (response) => {
        if (response?.data?.success) {
          setIsloading(false);
          setTimeout(() => {
            SuccessNotify("Add Post Successfully");
          }, 1000);
          navigate(`/recycle-profile/${id}`);
        }
      })
      .catch((e) => {
        setIsloading(false);
        FailedNotify("Failed To Post Try Again!");
      });
  };

  useEffect(() => {
    const resolvedUserId = shop?.userid?._id || shop?.userid || name?._id || "";
    const resolvedShopId = shop?._id || cleanShopId || id || "";
    if (!resolvedUserId && !resolvedShopId) return;

    const defaultCountry =
      shop?.resolvedCountry ||
      shop?.country ||
      shop?.userid?.address?.country ||
      shop?.userid?.country ||
      name?.address?.country ||
      name?.country ||
      "";
    const defaultState =
      shop?.resolvedRegion ||
      shop?.state ||
      shop?.userid?.address?.state ||
      shop?.userid?.state ||
      name?.address?.state ||
      name?.state ||
      "";
    const defaultCity =
      shop?.resolvedCity ||
      shop?.city ||
      shop?.userid?.address?.city ||
      shop?.userid?.city ||
      name?.address?.city ||
      name?.city ||
      name?.MCity ||
      "";

    setUserData((prev) => ({
      ...prev,
      userid: resolvedUserId || prev.userid,
      shopid: resolvedShopId || prev.shopid,
      country: prev.country || defaultCountry,
      state: prev.state || defaultState,
      city: prev.city || defaultCity,
    }));
  }, [shop, name, cleanShopId, id]);

  const FirstCategory = () => {
    url
      .get(`/category/type/?type=recycledShop&parentCategory=${mygetitem}`)
      .then(async (response) => {
        if (response?.data?.success) {
          setShopCategory(response?.data?.data?.Category);
        }
      })
      .catch((error) => {
        console.log("servicesCategories", error);
      });
  }
  const Mydata = () => {
    url
      .get(`/category/type/?type=recycledShopItem&parentCategory=${categoryName}`)
      .then(async (response) => {
        if (response?.data?.success) {
          setShopCategorytwo(response?.data?.data?.Category);
        }
      })
      .catch((error) => {
        console.log("servicesCategories", error);
      });
  };

  if (isloading) {
    return (
      <div>
        <Loader heightsetting="screenHeight" />
      </div>
    );
  }

  return (
    <PostAddForm
      Handledata={Handledata}
      Mydata={Mydata}
      data={data}
      shopCategorytwo={shopCategorytwo}
      shopCategory={shopCategory}
      postbtn="/recycle-profile"
      butn="Post"
      cancel="/recycle-profile/"
      back="/recycle-profile/"
      routename="/recycle-PostAdd"
      setUserData={setUserData}
      handlerFunction={userDatahandler}
      userData={userData}
      id={id}
      getInputProps={getInputProps}
      getRootProps={getRootProps}
      displayimg={displayimg}
      setDisplayimg={setDisplayimg}
      FirstCategory={FirstCategory}
      isUploading={isUploading}           
uploadProgress={uploadProgress}
    />
  );
};

export default RecyclePostAdd;
